<template>
    <div class="professional-attachments" :class="{ 'professional-attachments--makeup': theme === 'makeup' }">
        <strong>{{ title }}</strong>
        <p v-if="!attachments.length" class="professional-detail-copy">{{ emptyCopy }}</p>
        <div v-else class="professional-attachment-list">
            <template v-for="(attachment, index) in attachments">
                <el-image
                    v-if="isImage(attachment)"
                    :key="attachment.materialId || attachment.accessUrl || index"
                    class="professional-attachment-image"
                    :src="attachment.accessUrl"
                    :preview-src-list="imageUrls"
                    :initial-index="imageIndex(attachment)"
                    fit="cover"
                    @error="$emit('image-error')">
                    <div slot="placeholder" class="professional-image-placeholder">加载中…</div>
                    <div slot="error" class="professional-image-placeholder">图片无法加载</div>
                </el-image>
                <a
                    v-else
                    :key="attachment.materialId || attachment.accessUrl || index"
                    class="professional-attachment-link"
                    :href="attachment.accessUrl"
                    target="_blank"
                    rel="noopener noreferrer">{{ attachment.displayName || "查看附件" }}</a>
            </template>
        </div>
    </div>
</template>

<script>
import { isProfessionalApplicationImageAttachment } from "@/tool/creatorCenter.cjs";

export default {
    name: "ProfessionalApplicationAttachmentList",
    props: {
        title: {
            type: String,
            required: true,
        },
        attachments: {
            type: Array,
            default: () => [],
        },
        emptyCopy: {
            type: String,
            default: "暂无可展示的附件。",
        },
        theme: {
            type: String,
            default: "photographer",
        },
    },
    computed: {
        imageUrls() {
            return this.attachments
                .filter((attachment) => this.isImage(attachment))
                .map((attachment) => attachment.accessUrl);
        },
    },
    methods: {
        isImage(attachment) {
            return isProfessionalApplicationImageAttachment(attachment);
        },
        imageIndex(attachment) {
            return this.imageUrls.indexOf(attachment.accessUrl);
        },
    },
};
</script>

<style scoped>
.professional-attachments.professional-attachments--makeup > strong { color: #a95570; }
.professional-attachments.professional-attachments--makeup .professional-attachment-link { color: #b85d76; background: #fff0f4; }
.professional-attachments.professional-attachments--makeup .professional-attachment-link:hover { color: #fff; background: #d56886; }
.professional-attachments.professional-attachments--makeup .professional-attachment-image { border-color: #edbdc9; }
</style>
